import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PanoramaHorizontalSelectIcon(props: IconProps) {
    return <Icon {...props} iconKey={"panorama_horizontal_select"}/>
}
